/**
 * Currency codes supported by the Native Teams wallet.
 * Used to filter the full API currency list down to enabled currencies
 * across the wallet UI (creation, send money, claim expenses, etc.).
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const ALLOWED_WALLET_CURRENCY_CODES = [
  'AMD', // Armenian Dram
  'ARS', // Argentine Peso
  'AUD', // Australian Dollar
  'BAM', // Bosnia-Herzegovina Convertible Mark
  'BRL', // Brazilian Real
  'CAD', // Canadian Dollar
  'CNY', // Chinese Yuan
  'COP', // Colombian Peso
  'CZK', // Czech Koruna
  'EUR', // Euro
  'GBP', // British Pound
  'HKD', // Hong Kong Dollar
  'IDR', // Indonesian Rupiah
  'INR', // Indian Rupee
  'MAD', // Moroccan Dirham
  'MKD', // Macedonian Denar
  'MXN', // Mexican Peso
  'NGN', // Nigerian Naira
  'PKR', // Pakistani Rupee
  'PHP', // Philippine Peso
  'PLN', // Polish Zloty
  'RON', // Romanian Leu
  'RSD', // Serbian Dinar
  'SGD', // Singapore Dollar
  'TRY', // Turkish Lira
  'USD', // US Dollar
];

export const BANK_DETAILS_CURRENCIES = ['EUR', 'USD', 'GBP'];
